import { Dialog } from "@progress/kendo-react-dialogs";
import { CiWarning } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { closeErrorDialog } from "../../slices/errorDialogSlice";
import styles from "./ErrorDialog.module.scss";

export default function ErrorDialog() {
  const dispatch = useDispatch();
  const { open, message } = useSelector((state) => state.errorDialog);

  const formatMessages = (msg) => {
    if (!msg) return [];
    return msg
      .split(/\r?\n/)
      .filter((line) => line.trim())
      .map((line) => line.trim());
  };

  const messages = formatMessages(message);
  const isMultipleMessages = messages.length > 1;

  const handleClose = () => dispatch(closeErrorDialog());

  if (!open) return null;

  return (
    <Dialog
      title={null}
      onClose={handleClose}
      width={360}
      className="p-0 border-0"
    >
      <button
        type="button"
        onClick={handleClose}
        className={styles.closeButton}
        aria-label="Close"
      >
        ×
      </button>
      <div className={styles.root}>
        <div
          className={`d-flex flex-column align-items-center w-100 ${styles.inner}`}
        >
          <div className={styles.iconWrap}>
            <CiWarning size={64} aria-hidden />
          </div>
          <h3 className={`fs-lg fw-semibold text-dark ${styles.title}`}>
            Error Occurred
          </h3>
          <div
            className={`text-secondary ${styles.message} ${isMultipleMessages ? styles.messageMultiple : ""}`}
          >
            {isMultipleMessages ? (
              <ul className="list-unstyled mb-0 text-start">
                {messages.map((msg, index) => (
                  <li key={index} className="mb-2">
                    {msg}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="mb-0">{message}</p>
            )}
          </div>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </Dialog>
  );
}
